import { WorkspacePlaceholder } from './WorkspacePlaceholder';
import { WorkspaceShell } from './WorkspaceShell';

export function OperationsWorkspace(): JSX.Element {
  return (
    <WorkspaceShell title="Gestion Operativa" status="shell">
      <WorkspacePlaceholder
        title="Gestion Operativa"
        description="Gestionar servicios, recorridos, unidades, turnos, cuadrillas e incidencias del proyecto."
        capabilities={[
          'Servicios operativos por sector',
          'Unidades, vehiculos y recursos',
          'Recorridos y rutas operativas',
          'Turnos y cuadrillas',
          'Registro y seguimiento de incidencias',
        ]}
      />
    </WorkspaceShell>
  );
}
